'use client';
import { ButtonStyled } from './button.styles';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    tertiary: true;
  }
}

const Button = ButtonStyled;

export default Button;
